import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_TOKEN } from '../..';
import { ApiConstant } from '../../types';
import * as moment from 'moment';

const TRANSACTION_NAME = environment.elasticAPM.transactionName;

@Injectable({
    providedIn: 'root',
})
export class ShareSimulationService {
    baseUrl = `${this.apiConstants.endpoint}/Simulation`;

    constructor(@Inject(API_TOKEN) private apiConstants: ApiConstant, private httpClient: HttpClient) {}

    share(id: number): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Share simutaion' });
        const timeZoneOffset = moment().utcOffset();
        return this.httpClient.post(
            `${this.baseUrl}/SaveSimulation`,
            { simulationId: id, timeZoneOffset: timeZoneOffset },
            {
                headers,
            },
        );
    }

    sendMail(formData: FormData, mailList: string): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Send simutaion' });
        return this.httpClient.post(
            `${this.baseUrl}/SendEmailCommentSimulation?receiverAddress=${mailList}`,
            formData,
            {
                headers,
            },
        );
    }
}
